export default __webpack_public_path__ + "static/media/SweetPotatoFries.da97abfd.jpg";